import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { TopDishesResponse } from '../../types/feed';
import './TopDishCard.css';

type Item = TopDishesResponse['items'][number];

export function TopDishCard({ item }: { item: Item }) {
  const { t } = useTranslation();
  return (
    <Link
      to={`/r/${item.restaurant.slug}`}
      className="tdc"
      aria-label={`${item.name} — ${item.restaurant.name}`}
    >
      <div className="tdc-img-wrap">
        {item.imageUrl ? (
          <img src={item.imageUrl} alt="" className="tdc-img" />
        ) : (
          <div className="tdc-img tdc-img--fallback" />
        )}
        <span className="tdc-top-badge">{t('feed.topBadge')}</span>
      </div>
      <div className="tdc-body">
        <div className="tdc-name" title={item.name}>{item.name}</div>
        <div className="tdc-price">{item.price.toLocaleString('ru-RU')} ₸</div>
        <div className="tdc-restaurant">{item.restaurant.name}</div>
      </div>
    </Link>
  );
}
